// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#onboarding-step2-container .sentence1 {
    align-self: center;
  }
  #onboarding-step2-container .broad-container {
    font-size: 16px;
    font-weight: 100;
    margin-right: 2vw;
    max-width: 840px;
    display: flex
  }
  @media (max-width: 707px) {
  #onboarding-step2-container .broad-container {
      margin-right: 0
  }
    }
  #onboarding-step2-container #getting-started__header {
    font-size: 24px;
    font-weight: 400;
    margin-top: 0px;
    margin-bottom: 30px;
  }
  #onboarding-step2-container .header {
    font-size: 34px;
    font-weight: 700;
    margin-top: 0;
    margin-bottom: 20px
  }
  @media (max-width: 707px) {

  #onboarding-step2-container .header {
      font-size: 24px;
      margin-top: 10px;
      margin-bottom: 15px
  }
    }
  #onboarding-step2-container #main-flex-column {
    display: flex;
    flex-direction: column;
  }
  #onboarding-step2-container #mobile-icon-and-line-break {
    display: flex;
  }
  #onboarding-step2-container .no-top-margin {
    margin-top: 0;
  }
  #onboarding-step2-container #example-text {
    padding-left: 15px;
    margin-bottom: 3px
  }
  @media (max-width: 707px) {

  #onboarding-step2-container #example-text {
      margin-top: 10px
  }
    }
  #onboarding-step2-container #example-folded {
    display: flex;
    margin-top: 20px;
    margin-bottom: 5px;
  }
  #onboarding-step2-container .icon-container {
    transition: transform 0.3s ease;
  }
  #onboarding-step2-container .icon-container.rotated {
    transform: rotate(90deg);
  }
  #onboarding-step2-container .wrap-on-mobile {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    width: 100%
  }
  @media (max-width: 707px) {

  #onboarding-step2-container .wrap-on-mobile {
      flex-direction: column;
      width: 100%
  }
    }

#spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 45px;
  width: 100px;
}
#spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #6d239c;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Suceess Modal */
.onboarding-success {
  position: relative;
  left: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 16px;
  border: 1px solid #198c9d;
  background: #e8f3f5;
  width: 85%;
  padding: 35px 55px 35px 70px;
  margin-top: 15px;
  margin-bottom: 20px
}
@media (max-width: 707px) {
.onboarding-success {
    width: 80%;
    padding: 40px 30px 40px 40px
}
  }

/* Fail Modal */
.onboarding-fail {
  position: relative;
  left: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 16px;
  border: 1px solid #198c9d;
  background: #fbfbfb;
  width: 85%;
  padding: 35px 55px 35px 70px;
  margin-top: 15px;
  margin-bottom: 20px
}
@media (max-width: 707px) {
.onboarding-fail {
    width: 80%;
    padding: 40px 30px 20px 40px
}
  }
.fail-pagination {
  margin-top: 35px;
  display: flex;
  align-items: center;
  padding-left: 5px;
  justify-content: center;
}

.pagination-caret {
  cursor: pointer;
  font-size: 1.5rem;
  position: relative;
  top: -2px
}

.pagination-caret.left {
    left: -5px;
  }

.pagination-caret.right {
    right: -5px;
  }
.pagination-caret:hover {
  opacity: 0.7;
}

.cards-container-clip-overflow {
  position: relative;
  overflow: hidden;
  display: flex;
  min-height: calc(6 * 1.7em);
}
.msg {
  position: absolute;
  top: 0;
  left: 0;
  -webkit-user-select: none;
          user-select: none;
  width: 100%;
  height: 100%;
}

.msg.current {
  transform: translateX(0);
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none
}

.msg.current::-webkit-scrollbar {
    display: none;
  }

.waiting-left {
  transform: translateX(-100%);
}
.waiting-right {
  transform: translateX(100%);
}
/* For waiting cards sliding IN*/
.start-sliding-left,
.start-sliding-right {
  transform: translateX(0);
  transition: transform 0.2s ease-out;
}
/* For curr card sliding OUT */
.sliding-left {
  opacity: 0;
  transform: translateX(-100%);
}
.sliding-right {
  opacity: 0;
  transform: translateX(0);
}

/* mobile pagination carets */
.onboarding-fail__chevron {
  position: absolute;
  top: 41%;
  cursor: pointer;
}
.onboarding-fail__chevron svg path {
    stroke-width: 0.75;
  }
.onboarding-fail__chevron.left {
    left: -60px;
    transform: rotate(90deg);
  }
.onboarding-fail__chevron.right {
    right: -60px;
    transform: rotate(-90deg);
  }
`, "",{"version":3,"sources":["webpack://./src/pages/Onboarding/Step2.pcss"],"names":[],"mappings":"AAIE;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB;EAIF;EAHE;EANF;MAOI;EAEJ;IADE;EAEF;IACE,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,mBAAmB;EACrB;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb;EAMF;EALE;;EALF;MAMI,eAAe;MACf,gBAAgB;MAChB;EAEJ;IADE;EAGF;IACE,aAAa;IACb,sBAAsB;EACxB;EAEA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EAEA;IACE,kBAAkB;IAClB;EAIF;EAHE;;EAHF;MAII;EAEJ;IADE;EAGF;IACE,aAAa;IACb,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,+BAA+B;EACjC;EAEA;IACE,wBAAwB;EAC1B;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB;EAKF;EAJE;;EALF;MAMI,sBAAsB;MACtB;EAEJ;IADE;;AAIJ;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,4BAA4B;EAC5B,gBAAgB;EAChB;AAKF;AAJE;AAbF;IAcI,UAAU;IACV;AAEJ;EADE;;AAGF,eAAe;AACf;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,4BAA4B;EAC5B,gBAAgB;EAChB;AAKF;AAJE;AAbF;IAcI,UAAU;IACV;AAEJ;EADE;AAEF;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB;AAOF;;AANE;IACE,UAAU;EACZ;;AACA;IACE,WAAW;EACb;AAEF;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,yBAAiB;UAAjB,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,qBAAqB;EACrB;AAIF;;AAHE;IACE,aAAa;EACf;;AAGF;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;AACA,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,mCAAmC;AACrC;AACA,8BAA8B;AAC9B;EACE,UAAU;EACV,4BAA4B;AAC9B;AACA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,QAAQ;EACR,eAAe;AAYjB;AAXE;IACE,kBAAkB;EACpB;AACA;IACE,WAAW;IACX,wBAAwB;EAC1B;AACA;IACE,YAAY;IACZ,yBAAyB;EAC3B","sourcesContent":["$margin-for-icon: 180px;\n$mobile: 707px;\n\n#onboarding-step2-container {\n  .sentence1 {\n    align-self: center;\n  }\n  .broad-container {\n    font-size: 16px;\n    font-weight: 100;\n    margin-right: 2vw;\n    max-width: 840px;\n    display: flex;\n    @media (max-width: $mobile) {\n      margin-right: 0;\n    }\n  }\n  #getting-started__header {\n    font-size: 24px;\n    font-weight: 400;\n    margin-top: 0px;\n    margin-bottom: 30px;\n  }\n\n  .header {\n    font-size: 34px;\n    font-weight: 700;\n    margin-top: 0;\n    margin-bottom: 20px;\n    @media (max-width: $mobile) {\n      font-size: 24px;\n      margin-top: 10px;\n      margin-bottom: 15px;\n    }\n  }\n\n  #main-flex-column {\n    display: flex;\n    flex-direction: column;\n  }\n\n  #mobile-icon-and-line-break {\n    display: flex;\n  }\n  .no-top-margin {\n    margin-top: 0;\n  }\n\n  #example-text {\n    padding-left: 15px;\n    margin-bottom: 3px;\n    @media (max-width: $mobile) {\n      margin-top: 10px;\n    }\n  }\n\n  #example-folded {\n    display: flex;\n    margin-top: 20px;\n    margin-bottom: 5px;\n  }\n  .icon-container {\n    transition: transform 0.3s ease;\n  }\n\n  .icon-container.rotated {\n    transform: rotate(90deg);\n  }\n\n  .wrap-on-mobile {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    width: 100%;\n    @media (max-width: $mobile) {\n      flex-direction: column;\n      width: 100%;\n    }\n  }\n}\n\n#spinner-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 45px;\n  width: 100px;\n}\n#spinner {\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #6d239c;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n}\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Suceess Modal */\n.onboarding-success {\n  position: relative;\n  left: 40px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  border-radius: 16px;\n  border: 1px solid #198c9d;\n  background: #e8f3f5;\n  width: 85%;\n  padding: 35px 55px 35px 70px;\n  margin-top: 15px;\n  margin-bottom: 20px;\n  @media (max-width: $mobile) {\n    width: 80%;\n    padding: 40px 30px 40px 40px;\n  }\n}\n\n/* Fail Modal */\n.onboarding-fail {\n  position: relative;\n  left: 40px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  border-radius: 16px;\n  border: 1px solid #198c9d;\n  background: #fbfbfb;\n  width: 85%;\n  padding: 35px 55px 35px 70px;\n  margin-top: 15px;\n  margin-bottom: 20px;\n  @media (max-width: $mobile) {\n    width: 80%;\n    padding: 40px 30px 20px 40px;\n  }\n}\n.fail-pagination {\n  margin-top: 35px;\n  display: flex;\n  align-items: center;\n  padding-left: 5px;\n  justify-content: center;\n}\n\n.pagination-caret {\n  cursor: pointer;\n  font-size: 1.5rem;\n  position: relative;\n  top: -2px;\n  &.left {\n    left: -5px;\n  }\n  &.right {\n    right: -5px;\n  }\n}\n.pagination-caret:hover {\n  opacity: 0.7;\n}\n\n.cards-container-clip-overflow {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  min-height: calc(6 * 1.7em);\n}\n.msg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  user-select: none;\n  width: 100%;\n  height: 100%;\n}\n\n.msg.current {\n  transform: translateX(0);\n  overflow-y: scroll;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.waiting-left {\n  transform: translateX(-100%);\n}\n.waiting-right {\n  transform: translateX(100%);\n}\n/* For waiting cards sliding IN*/\n.start-sliding-left,\n.start-sliding-right {\n  transform: translateX(0);\n  transition: transform 0.2s ease-out;\n}\n/* For curr card sliding OUT */\n.sliding-left {\n  opacity: 0;\n  transform: translateX(-100%);\n}\n.sliding-right {\n  opacity: 0;\n  transform: translateX(0);\n}\n\n/* mobile pagination carets */\n.onboarding-fail__chevron {\n  position: absolute;\n  top: 41%;\n  cursor: pointer;\n  svg path {\n    stroke-width: 0.75;\n  }\n  &.left {\n    left: -60px;\n    transform: rotate(90deg);\n  }\n  &.right {\n    right: -60px;\n    transform: rotate(-90deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
